module.exports = __webpack_public_path__ + "static/media/goods10.c726229e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/goods10.png
// module id = 216
// module chunks = 0